var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.28 9.97-7.5-7.5A.75.75 0 0 0 13.5 3v3.783c-2.432.208-5.118 1.399-7.327 3.273-2.661 2.257-4.318 5.166-4.665 8.19a1.125 1.125 0 0 0 1.938.899c1.031-1.098 4.7-4.57 10.054-4.875V18a.75.75 0 0 0 1.28.53l7.5-7.5a.75.75 0 0 0 0-1.06M15 16.19V13.5a.75.75 0 0 0-.75-.75c-2.633 0-5.197.687-7.62 2.044A18.4 18.4 0 0 0 3.2 17.28c.544-2.235 1.915-4.36 3.943-6.08 2.177-1.847 4.834-2.95 7.107-2.95A.75.75 0 0 0 15 7.5V4.811l5.69 5.689z"
  })));
};
export default SvgShare;